<template>
  <modal
    v-slot="{ data }"
    name="notice-modal"
    modal-style="compact"
    :display-header-title="false"
  >
    <notice :data="data" />
  </modal>
</template>


<script>
  import Notice from './notice/index.vue';

  export default {
    name: 'NoticeModal',

    components: {
      Notice
    }
  };
</script>
